<template>
  <div class="container">
    <el-button
      class="mwow-button-filled primary export-button"
      @click="handleExport"
      v-debounce="5000"
    >
      导出
    </el-button>

    <div style="min-height: 210px">
      <el-table
        :data="tableData"
        v-horizontal-scroll
        stripe
        style="width: 100%"
        @sort-change="handleSortChange"
        :default-sort="{
          order: 'descending',
          prop: 'transform_amount',
        }"
      >
        <el-table-column
          prop="teacher.name"
          label="授课教师"
          fixed
        ></el-table-column>
        <el-table-column
          prop="student_num"
          min-width="150"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            在读学员数
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                查询时间第一天0点,老师关联的学员人数,按学员去重
              </div>
              <span>
                <i class="icon-question el-icon-question"></i>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="active_student_num"
          min-width="150"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            耗课学员数
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                老师关联的学员,且在查询时间范围内有耗课的学员人数,按学员去重
              </div>
              <span>
                <i class="icon-question el-icon-question"></i>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="active_rate_2"
          min-width="150"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            活跃率
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                耗课学员人数/在读学员人数*100%,保留两位小数
              </div>
              <span>
                <i class="icon-question el-icon-question"></i>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { studentActiveTeacherListApi } from "@/api/statistics";
import { dateFormat, getCurrentMonth } from "@/utils/timeFormat";
import json2csv from "json2csv";
import { roundNumbers } from "@/utils/roundNumbers";

export default {
  props: ["date-range"],
  data() {
    return {
      tableData: [],
      currentSortOption: {
        order: "descending",
        prop: "",
      },
      exporting: false,
    };
  },
  watch: {
    dateRange() {
      this.handleSearch();
    },
  },
  methods: {
    handleSearch() {
      this.getList(this.dateRange[0], this.dateRange[1]);
    },
    getList(start, end) {
      studentActiveTeacherListApi({
        start_date: start,
        end_date: end,
      }).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((v) => {
            v.active_rate_2 = roundNumbers(v.active_rate) + "%"; //活跃率
          });
          this.tableData = res.data.list;
        }
      });
    },
    handleSortChange(val) {
      this.currentSortOption = {
        order: val.order,
        prop: val.prop,
      };
      this.tableData = this.sortList(this.tableData);
      let n = 0;
      this.tableData.map((it) => {
        n += 1;
        it.ranking = n;
      });
    },
    sortList(val) {
      const copy = [...val];
      copy.sort((a, b) => {
        return (
          Number(b[this.currentSortOption.prop]) -
          Number(a[this.currentSortOption.prop])
        );
      });
      copy.map((it, ind) => {
        it.ind = ind + 1;
      });
      if (this.currentSortOption.order === "ascending") {
        copy.reverse();
      }
      return copy;
    },
    // 导出
    handleExport() {
      if (this.exporting) {
        return false;
      }
      this.exporting = true;
      const date = new Date().getTime();
      const dateTime = dateFormat("YYYYmmddHHMMSS", date);
      const endThree = String(date).slice(-3, date.length);
      const newExportData = JSON.parse(JSON.stringify(this.tableData));
      try {
        const result = json2csv.parse(
          [
            {
              "teacher.name": "授课教师",
              student_num: "在读学员人数",
              active_student_num: "耗课学员人数",
              active_rate: "活跃率",
            },
            ...newExportData,
          ],
          {
            fields: [
              "teacher.name",
              "student_num",
              "active_student_num",
              "active_rate",
            ],
            header: false,
          }
        );
        // 非IE浏览器
        const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
        // 创建a标签下载
        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = "学员数据-老师明细" + dateTime + endThree;
        (".csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // 3秒导出间隔
        setTimeout(() => {
          this.exporting = false;
        }, 3000);
        this.$message({
          message: "导出成功",
          type: "success",
        });
      } catch (err) {
        this.$message({
          type: "error",
          message: err.toString(),
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  border-radius: 4px;
  position: relative;

  .export-button {
    position: absolute;
    top: -77px;
    right: 8px;
    z-index: 100;
  }
  .icon-question {
    margin-left: 2px;
    color: #bebfc0;
    font-size: 16px;
    vertical-align: text-bottom;
  }
}
</style>
